import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import TrustBar from '../../../components/feature/TrustBar';
import ProcessSection from '../../../components/feature/ProcessSection';
import WhyChooseUsSection from '../../../components/feature/WhyChooseUsSection';
import TestimonialsSection from '../../../components/feature/TestimonialsSection';
import FAQSection from '../../../components/feature/FAQSection';
import FinalCTASection from '../../../components/feature/FinalCTASection';
import ServiceAreasSection from '../../../components/feature/ServiceAreasSection';
import AIAnswerBlock from '../../../components/feature/AIAnswerBlock';
import MidPageCTA from '../../../components/feature/MidPageCTA';
import AsbestosHero from './components/AsbestosHero';
import AsbestosServicesOverview from './components/AsbestosServicesOverview';

const asbestosFAQs = [
  {
    question: 'What is asbestos abatement and why is it needed?',
    answer:
      'Asbestos abatement is the certified process of identifying, containing, and safely removing asbestos-containing materials to prevent airborne fiber exposure and serious health risks. It is required by law during renovations, demolitions, or when asbestos is damaged or deteriorating in commercial or industrial buildings.',
  },
  {
    question: 'Is asbestos removal required by law in Colorado?',
    answer:
      'Yes. Colorado regulations and federal EPA/OSHA standards require certified professional handling and removal in commercial properties, during renovations, and in any regulated building. Failure to comply can result in major fines, project shutdowns, and liability exposure for property owners.',
  },
  {
    question: 'How do I know if my building contains asbestos?',
    answer:
      'Testing is required to confirm asbestos — visual inspection alone is insufficient. ECOS Environmental performs certified inspections including bulk material sampling and lab analysis to confirm presence, fiber type, and appropriate abatement action plan. Testing is the only reliable way to know.',
  },
  {
    question: 'How long does asbestos abatement take?',
    answer:
      'Timeline depends on contamination scope and building size. Small commercial projects typically take 1 to 3 days. Larger industrial or high-contamination environments can require 1 to 3 weeks. ECOS provides project-specific timelines after the initial site assessment.',
  },
  {
    question: 'Who provides certified asbestos abatement near me in Colorado?',
    answer:
      'ECOS Environmental & Disaster Restoration provides certified asbestos abatement across Colorado including Colorado Springs, Denver, Pueblo, and the entire Front Range. All work is performed by licensed specialists with complete EPA/OSHA compliance documentation provided.',
  },
];

export default function AsbestosAbatementPage() {
  return (
    <main>
      <Navbar />
      <AsbestosHero />
      <TrustBar />
      <AsbestosServicesOverview />
      <MidPageCTA
        headline="Suspect Asbestos in Your Building? Don't Wait."
        subtext="Get a certified asbestos inspection and action plan. 24/7 emergency testing available."
      />
      <AIAnswerBlock
        question="What Is Asbestos Abatement?"
        answer="Asbestos abatement is the safe removal and disposal of asbestos-containing materials to prevent exposure risks and health hazards. ECOS Environmental follows strict EPA and OSHA guidelines to ensure safe containment, certified removal, and post-remediation air clearance testing. All work is performed by licensed Colorado asbestos abatement professionals with complete documentation and clearance certificates provided upon project completion."
        services={[
          { label: 'Asbestos Inspection' },
          { label: 'Bulk Sampling & Lab Testing' },
          { label: 'Containment & Removal' },
          { label: 'Clearance Air Testing' },
          { label: 'Disposal Manifests' },
          { label: 'Regulatory Documentation' },
        ]}
      />
      <ProcessSection title="Our Certified Asbestos Abatement Process" />
      <WhyChooseUsSection headline="Safe, Certified, and Fully Compliant Asbestos Removal" />
      <ServiceAreasSection locationNote="Colorado for Asbestos Abatement" />
      <TestimonialsSection />
      <MidPageCTA
        headline="Questions About Your Asbestos Project?"
        subtext="Speak directly with a certified asbestos abatement specialist — no obligation."
      />
      <FAQSection faqs={asbestosFAQs} title="Asbestos Abatement Questions Answered" />
      <FinalCTASection />
      <Footer />
    </main>
  );
}
